import { Skeleton } from '@/components/ui/Skeleton.tsx';

export const ConsentTemplateFormSkeleton = () => (
  <div className="space-y-4">
    {/* Nazwa input */}
    <div className="space-y-1.5">
      <Skeleton className="h-4 w-16" />
      <Skeleton className="h-10 w-full" />
    </div>

    {/* Rich text editor area */}
    <div className="space-y-1.5">
      <Skeleton className="h-4 w-28" />
      <Skeleton className="h-32 w-full" />
    </div>
  </div>
);
